import Drawable from '../entities/Drawable.js';
import OptionsBox from './OptionsBox.js';

export default class PauseMenuUI extends Drawable {
    constructor({ stateMachine }) {
        super();
        this.stateMachine = stateMachine;
        this.visible = false;
        this.currentOption = 0;

        const playerName = this.stateMachine.player.name.toUpperCase();
        this.pauseMenuBox = new OptionsBox({
            position: { x: 160, y: 8 },
            options: this.stateMachine.pauseMenu.getOptions(),
            selectedOption: 0,
            visible: false,
            wide: playerName.length >= 8,
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.pauseMenuBox.setOptions(
            this.stateMachine.pauseMenu.getOptions(),
            this.stateMachine.player.name.length > 8
        );
        this.pauseMenuBox.options = this.stateMachine.pauseMenu.getOptions();
        this.pauseMenuBox.selectedOption = this.stateMachine.pauseMenu.currentOption;
        this.pauseMenuBox.visible = this.visible;
        this.pauseMenuBox.draw();
    }
}
